import React, { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import { Form, Row, Col, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { MdDelete } from "react-icons/md";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import SelectAutocompleteIF from "../../../../components/UI/SelectAutocomplete/SelectAutocompleteIF";
// import ButtonImage from "../../../../components/UI/Button/ButtonImage";

const FormAtividadeIF1 = ({ formik, field, dataInicial, dataFinal, sqComunicado, sqComunicadoIF1 }) => {
  const { request, data, errors } = useApiClient();
  const [rowCategoriaLivro, setRowCategoriaLivro] = useState();
  const [rowCategoriaLivroTemp, setRowCategoriaLivroTemp] = useState();
  const [sequencialLivroSelecionado, setSequencialLivroSelecionado] = useState([]);
  const [livrosAdicionados, setLivrosAdicionados] = useState([]);

  const { request: requestLivrosSalvos, data: dataLivrosSalvos, errors: errorsLivrosSalvos } = useApiClient();

  const startYear = new Date(dataInicial).getFullYear();
  const endYear = new Date(dataFinal).getFullYear();
  const years = [];

  for (let year = startYear; year <= endYear; year += 1) {
    years.push(year);
  }

  useEffect(() => {
    request(apiRoutes.fiscalizacao.ordemservico.consultaLivrosFiscais);
  }, [request]);

  useEffect(() => {
    if (!data && !errors) return;

    if (data) {
      const categorias = data?.result.filter((item) => item.tipoCategoria !== "AM");
      setRowCategoriaLivro(_.sortBy(categorias, ["descricaoCategoria"]));
    }

    if (errors) toast.error(errors.message);
  }, [data, errors]);

  const carregarLivrosSalvos = useCallback(
    (seq) => {
      requestLivrosSalvos(apiRoutes.fiscalizacao.ordemservico.consultaLivrosFiscaisSalvos, { sqComunicado: seq });
    },
    [requestLivrosSalvos],
  );

  useEffect(() => {
    if (sqComunicado && formik?.values?.siglaAtividade !== "AUGEIMDODE") {
      carregarLivrosSalvos(sqComunicado);
    } else if (sqComunicadoIF1) {
      carregarLivrosSalvos(sqComunicadoIF1);
    }
  }, [carregarLivrosSalvos, sqComunicado, sqComunicadoIF1, formik?.values?.siglaAtividade]);

  useEffect(() => {
    if (!dataLivrosSalvos && !errorsLivrosSalvos) return;

    if (dataLivrosSalvos) {
      const categoriasTemp = dataLivrosSalvos?.result.filter((item) => item.tipoCategoria !== "AM");
      setRowCategoriaLivroTemp(_.sortBy(categoriasTemp, ["descricaoCategoria"]));

      const livrosSalvos = dataLivrosSalvos?.result.filter((item) => item.tipoCategoria !== "AM");
      setRowCategoriaLivroTemp(_.sortBy(livrosSalvos, ["descricaoCategoria"]));
    }

    if (errorsLivrosSalvos) toast.error(errorsLivrosSalvos.message);
  }, [dataLivrosSalvos, errorsLivrosSalvos]);

  const changeHandlerAll = (event, sqLivro, anos) => {
    const updatedLivros = [...formik.values.livrosFiscais];

    if (event.target.checked) {
      anos.map((itemAnoAll) => {
        const codigoAnoAll = [itemAnoAll];
        document.getElementById(`${sqLivro}#${codigoAnoAll}`).checked = true;

        if (
          event.target.checked &&
          updatedLivros.indexOf(document.getElementById(`${sqLivro}#${codigoAnoAll}`).value) === -1
        ) {
          updatedLivros.push(document.getElementById(`${sqLivro}#${codigoAnoAll}`).value);
        }

        return codigoAnoAll;
      });
    } else {
      anos.map((itemAnoAll) => {
        const codigoAnoAll = [itemAnoAll];

        document.getElementById(`${sqLivro}#${codigoAnoAll}`).checked = false;
        updatedLivros.splice(updatedLivros.indexOf(document.getElementById(`${sqLivro}#${codigoAnoAll}`).value), 1);

        return codigoAnoAll;
      });
    }
    formik.setFieldValue("livrosFiscais", updatedLivros);
  };

  const changeHandler = (event) => {
    const updatedLivros = [...formik.values.livrosFiscais];

    if (event.target.checked && updatedLivros.indexOf(event.target.value) === -1) {
      updatedLivros.push(event.target.value);
    } else {
      updatedLivros.splice(updatedLivros.indexOf(event.target.value), 1);
    }
    formik.setFieldValue("livrosFiscais", updatedLivros);
  };

  const livrosCarregados = [];
  formik.values.livrosFiscais.forEach((item) => {
    livrosCarregados.push(item);
  });

  // Para extrair os valores do ID e do ano de cada elemento do array:
  const livrosFiscaisSalvos = livrosCarregados.map((item) => {
    const [sequencialLivroSalvo] = item.split("#");
    return { sequencialLivroSalvo: Number(sequencialLivroSalvo) };
  });

  const handleSelectAutoInput = (value, i) => {
    sequencialLivroSelecionado[i] = value;
    setSequencialLivroSelecionado([...sequencialLivroSelecionado]);
  };

  const DelLivroSelecionado = (livro, index) => {
    const updatedLivros = [...formik.values.livrosFiscais];
    const updatedLivrosRetirar = [...livrosAdicionados[index].livros];
    const livroASerRemovido = livro.sequencialLivro;
    // Encontrando o índice do livro a ser removido no array
    const indexDoLivro = updatedLivrosRetirar.findIndex((result) => result.sequencialLivro === livroASerRemovido);

    // Removendo os anos do livro do array do formik
    if (indexDoLivro !== -1) {
      years.map((itemAnoAll) => {
        const codigoAnoAll = [itemAnoAll];

        const valor = `${livroASerRemovido}#${codigoAnoAll}`;

        const existe = updatedLivros?.find((result) => result === valor);
        // document.getElementById(`${livroASerRemovido}#${codigoAnoAll}`).checked = false;
        if (existe) {
          updatedLivros.splice(updatedLivros.indexOf(valor), 1);
        }

        return codigoAnoAll;
      });
      formik.setFieldValue("livrosFiscais", updatedLivros);

      // Removendo o livro dos arrays
      updatedLivrosRetirar.splice(indexDoLivro, 1);
      // Atualize livrosAdicionados com o novo array
      livrosAdicionados[index].livros = updatedLivrosRetirar;

      // Removendo o livro dos arrays se rowCategoriaLivroTemp[index] existir
      if (rowCategoriaLivroTemp[index]) {
        const updatedCategoriaLivroTemp = [...rowCategoriaLivroTemp[index].livrosFiscais];
        updatedCategoriaLivroTemp.splice(indexDoLivro, 1);
        rowCategoriaLivroTemp[index].livrosFiscais = updatedCategoriaLivroTemp;
      }
    }

    setLivrosAdicionados([...livrosAdicionados]);
  };

  const AddLivroSelecionado = (livro, index) => {
    if (!sequencialLivroSelecionado[index]) {
      toast.warning("É preciso selecionar uma opção!");
      return;
    }

    const existe = livrosAdicionados[index]?.livros?.find((result) => result.sequencialLivro === livro.sequencialLivro);
    if (existe) {
      toast.warning("Já adicionado!");
    } else {
      const livros = livrosAdicionados[index]?.livros || [];
      livros.push(livro);
      livrosAdicionados[index] = { livros };
      setLivrosAdicionados([...livrosAdicionados]);
    }
  };

  // Função adicionarLivrosFiscaisSalvos utilizando useCallback
  const adicionarLivrosFiscaisSalvos = useCallback(() => {
    const updatedLivrosAdicionadosAll = [...livrosAdicionados];
    if (rowCategoriaLivroTemp && rowCategoriaLivroTemp.length > 0) {
      if (livrosFiscaisSalvos && livrosFiscaisSalvos.length > 0) {
        rowCategoriaLivroTemp.forEach((item, index) => {
          const livros = item.livrosFiscais;

          updatedLivrosAdicionadosAll[index] = { livros };
          livrosAdicionados[index] = { livros };
        });
      }
    }
    return updatedLivrosAdicionadosAll;
  }, [rowCategoriaLivroTemp, livrosFiscaisSalvos, livrosAdicionados]); // Adicione as dependências necessárias

  return (
    <div style={{ width: "100%" }} onLoad={adicionarLivrosFiscaisSalvos()}>
      {rowCategoriaLivro?.length > 0 ? (
        rowCategoriaLivro.map((item, index) => {
          const itemCateg = (
            <>
              <h6
                key={item}
                className="m-0 font-weight-bold text-primary flex-grow-1"
                style={{ textTransform: "uppercase" }}
              >
                {item.descricaoCategoria}
              </h6>
              <Row>
                <Col sm={8} md={6} style={{ padding: "0px" }}>
                  <Form.Group as={Col} sm={12} md={12}>
                    <SelectAutocompleteIF
                      options={item.livrosFiscais}
                      optionLabel="nomeLivro"
                      optionValue="sequencialLivro"
                      maxOptions="600"
                      id={sequencialLivroSelecionado[index]?.sequencialLivro}
                      value={sequencialLivroSelecionado[index]?.sequencialLivro}
                      onChange={(selectedValue) => {
                        const selecionado = _.find(
                          item.livrosFiscais,
                          (livro) => livro.sequencialLivro === selectedValue,
                        );

                        handleSelectAutoInput(selecionado, index);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col sm={4} md={6} style={{ padding: "0px", marginTop: "3px" }}>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => AddLivroSelecionado(sequencialLivroSelecionado[index], index)}
                  >
                    +
                  </Button>
                </Col>
              </Row>
              {livrosAdicionados[index] ? (
                <Row style={{ marginBottom: "30px" }}>
                  <Col sm={4} md={6} style={{ paddingLeft: "20px", paddingBottom: "20px", marginTop: "3px" }}>
                    <ul className="list-group">
                      {livrosAdicionados[index].livros.map((itemLivros) => {
                        const sequencialLivro = [itemLivros.sequencialLivro];

                        const livros = (
                          <li
                            style={{
                              borderBottom: "1px solid rgba(0, 0, 0, 0.125)",
                              paddingTop: "10px",
                            }}
                            key={itemLivros.nomeLivro}
                          >
                            {itemLivros.nomeLivro}
                            {"    "}
                            <Button
                              className="mr-0 btn btn-light btn-md btn-user mx-3 p-1"
                              onClick={() => DelLivroSelecionado(itemLivros, index)}
                            >
                              <MdDelete />
                            </Button>
                            <br />
                            <Form.Check
                              inline
                              key={sequencialLivro}
                              type="checkbox"
                              id={sequencialLivro}
                              name="checarTodos"
                              label="Todos os anos"
                              disabled={formik.isSubmitting}
                              onChange={(event) => changeHandlerAll(event, sequencialLivro, years)}
                            />
                            {"  "}
                            {years.map((itemAno) => {
                              const codigoAno = [itemAno];
                              const listaAnos = (
                                <Form.Check
                                  inline
                                  key={itemAno}
                                  type="checkbox"
                                  id={`${sequencialLivro}#${codigoAno}`}
                                  value={[`${sequencialLivro}#${codigoAno}`]}
                                  name="livrosFiscais"
                                  label={[itemAno]}
                                  disabled={formik.isSubmitting}
                                  onChange={(event) => changeHandler(event)}
                                  defaultChecked={
                                    !!formik.values.livrosFiscais.find(
                                      (element) => element === `${sequencialLivro}#${codigoAno}`,
                                    )
                                  }
                                />
                              );
                              return listaAnos;
                            })}
                          </li>
                        );
                        return livros;
                      })}
                      {formik.errors[field] && (
                        <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
                      )}
                    </ul>
                  </Col>
                </Row>
              ) : (
                ""
              )}
            </>
          );
          return itemCateg;
        })
      ) : (
        <span className="m-0 font-weight-bold text-primary flex-grow-1 px-2">Nenhuma Categoria encontrada</span>
      )}
    </div>
  );
};

export default FormAtividadeIF1;
